import React, { useEffect, useState } from "react";
import "./UnsubscribePage.css";
import { unsubscribeDetailsAsync } from "../../_redux/_services/UserManagerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";

const UnsubscribePage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch(unsubscribeDetailsAsync(id))
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [id, dispatch]);

  // Read data from the Redux store
  const { data: unsubscribeData } = useSelector((state) => state.UnsubscribeDetails);

  // Navigate to 404 page if API call finished and unsubscribeData is null
  useEffect(() => {
    if (!loading && !unsubscribeData) {
      navigate("/layout/unsubscribe");
    }
  }, [loading, unsubscribeData, navigate]);

  if (loading) {
    return null; // Global loader will handle the loading overlay display
  }

  const email = unsubscribeData?.email;
  const companyName = unsubscribeData?.companyName;

  return (
    <div className="unsubscribe-container" id="unsubscribe-page">
      <div className="unsubscribe-content">
        {/* Dynamic Company Name */}
        <h2 className="unsubscribe-company" id="unsubscribe-company-name">
          {companyName}
        </h2>

        {/* Circular Checkmark Badge */}
        <div className="unsubscribe-icon-circle" id="unsubscribe-badge">
          <svg
            width="42"
            height="42"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        {/* Title */}
        <h1 className="unsubscribe-title" id="unsubscribe-title-text">
          Thank You!
        </h1>

        {/* Card Component */}
        <div className="unsubscribe-card" id="unsubscribe-card-box">
          <div className="unsubscribe-card-label" id="unsubscribe-label">
            Email Removed
          </div>
          <p className="unsubscribe-card-text" id="unsubscribe-details">
            <span className="unsubscribe-email" id="unsubscribe-user-email">
              {email}
            </span>{" "}
            is unsubscribed from future communication
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnsubscribePage;
